import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditCalendarHolidaysFailure({ uuid }) {
      const req = getState().find(
        ({ calendarHolidays }) => calendarHolidays.uuid === uuid,
      );
      return req ? req.request.isFailure : false;
    },
    isEditCalendarHolidayRequestPending({ uuid }) {
      const req = getState().find(
        ({ calendarHolidays }) => calendarHolidays.uuid === uuid,
      );
      return req ? req.request.isPending : false;
    },
    isEditCalendarHolidaysSuccess({ uuid }) {
      const req = getState().find(
        ({ calendarHolidays }) => calendarHolidays.uuid === uuid,
      );
      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
